var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60714 15.3214L1.60714 12.4286C1.60714 12 1.28572 11.5714 0.750001 11.5714C0.214286 11.5714 0 12 0 12.4286L0 18H5.57143C6 18 6.42858 17.6786 6.42858 17.25C6.42858 16.8214 6.10715 16.5 5.67858 16.5H2.67857L7.60715 11.5714C7.71429 11.4643 7.82143 11.25 7.82143 11.0357C7.82143 10.8214 7.71429 10.6072 7.60715 10.5C7.28572 10.1786 6.75 10.1786 6.42858 10.5L1.60714 15.3214Z",
    fill: "#204354"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6786 0.749996C11.6786 1.17857 12 1.5 12.4286 1.5H15.3214L10.5 6.32141C10.1786 6.64284 10.1786 7.17855 10.5 7.49998C10.8214 7.82141 11.3571 7.82141 11.6786 7.49998L16.5 2.67856V5.57141C16.5 5.99998 16.8214 6.32141 17.25 6.32141C17.6786 6.32141 18 5.99998 18 5.57141V0H12.4286C12 0 11.6786 0.321426 11.6786 0.749996Z",
    fill: "#204354"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.c934515e4278d2c499901a47b62702cb.svg";
export { ForwardRef as ReactComponent };